import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import Swal from 'sweetalert2';

// ===== IMPORTS DE IMÁGENES =====
import logoRD from './assets/logoasesor.png';
import fondosalud from './assets/calculadorasalud.webp';
import fondovivienda from './assets/calculadoravivienda.webp';
import fondoeventoespecial from './assets/calculadoraeventoespecial.webp';
import fondojubilacion from './assets/calculadorajubilacion.webp';
import fondoeducacion from './assets/calculadoraeducacion.webp';
import fondovacaciones from './assets/calculadoravacaciones.webp';

// ===== DATOS ESTÁTICOS =====
const plans = [
  {
    title: "Vivienda",
    description: "Planea tu ahorro para la remodelación de tu hogar o la adquisición de uno",
    image: fondovivienda,
  },
  {
    title: "Evento Especial",
    description: "Realiza tu evento especial con tu plan de ahorro",
    image: fondoeventoespecial,
  },
  {
    title: "Fondo de salud",
    description: "Crea un fondo para tu seguridad médica mediante un ahorro",
    image: fondosalud,
  },
  {
    title: "Fondo de retiro",
    description: "Crea un fondo para tu retiro de vida",
    image: fondojubilacion,
  },
  {
    title: "Fondo Educacion",
    description: "Crea un fondo para la futura educación",
    image: fondoeducacion,
  },
  {
    title: "Fondo de vacaciones",
    description: "Crea un fondo para tus vacaciones de en sueño",
    image: fondovacaciones,
  },
];

const seguros = [
  {
    title: "Seguro de Auto",
    description: "Protege tu vehículo contra accidentes y robos",
    image: "https://acnews.blob.core.windows.net/imgnews/medium/NAZ_e6191295462248b2aab6962ce7f6a66b.jpg"
  },
  {
    title: "Seguro de Vida",
    description: "Asegura el bienestar de tu familia",
    image: "https://www.rastreator.mx/wp-content/uploads/que-es-un-seguro-de-vida.jpg"
  },
  {
    title: "Seguro de Hogar",
    description: "Protege tu casa y tus bienes",
    image: "https://blog.socasesores.com/wp-content/uploads/2022/12/seguro-de-casa-1024x762.webp"
  },
  {
    title: "Seguro Médico",
    description: "Cuida tu salud con la mejor cobertura",
    image: "https://seguroshcid.com/wp-content/uploads/2022/09/seguros-salud-1024x683-1.jpeg"
  },
  {
    title: "Seguro de viajes",
    description: "Cuida de ti durante tu viaje",
    image: "https://media.istockphoto.com/id/1350713547/es/vector/concepto-de-banner-de-seguro-de-viaje-maleta-de-equipaje-de-viaje-roja-y-protecci%C3%B3n-de-viaje.jpg?s=612x612&w=0&k=20&c=y8KiDKDzTm5g5eSGpy-Ltw5xtR8ZdbljdCPeXKzpAuQ="
  },
];

// ===== ESTILOS =====
const inputStyle = {
  width: '100%',
  padding: '10px',
  marginBottom: '15px',
  borderRadius: '8px',
  border: '1px solid #ccc',
  fontSize: '1rem',
  boxSizing: 'border-box'
};

const buttonStyle = {
  width: '100%',
  backgroundColor: '#0c1f4d',
  color: 'white',
  padding: '12px',
  fontSize: '1rem',
  borderRadius: '25px',
  border: 'none',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease'
};

const navLinkStyle = {
  color: 'white',
  textDecoration: 'none',
  cursor: 'pointer',
  fontWeight: 600,
  padding: '2px 5px',
  transition: 'color 0.2s',
};

// ===== COMPONENTE SIMULADOR =====
function CalculadoraSoloAhorrar() {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [edad, setEdad] = useState("");
  const [ingreso, setIngreso] = useState("");
  const [tiempo, setTiempo] = useState("");
  const [crecimiento] = useState("9");

  const handleSubmit = () => {
    // Validaciones
    if (!nombre || !edad || !ingreso || !tiempo) {
      Swal.fire({
        icon: "warning",
        title: "Campos incompletos",
        text: "Por favor, completa todos los campos.",
      });
      return;
    }

    if (isNaN(edad) || edad <= 0 || edad > 99) {
      Swal.fire({
        icon: "error",
        title: "Edad inválida",
        text: "Por favor, ingresa una edad válida entre 1 y 99.",
      });
      return;
    }

    if (isNaN(ingreso) || ingreso <= 0) {
      Swal.fire({
        icon: "error",
        title: "Ingreso inválido",
        text: "El ingreso debe ser un número mayor que cero.",
      });
      return;
    }

    navigate("/DisplayCalculo", {
      state: { nombre, edad, ingreso, tiempo, crecimiento }
    });
  };

  return (
    <div style={{
      backgroundColor: 'white',
      borderRadius: '15px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      padding: '25px',
      maxWidth: '400px',
      margin: '40px auto',
      fontFamily: 'sans-serif'
    }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Simulador</h2>
      
      <label>Nombre:</label>
      <input 
        type="text" 
        value={nombre} 
        onChange={(e) => setNombre(e.target.value)} 
        style={inputStyle} 
      />
      
      <label>Edad:</label>
      <input
        type="number"
        value={edad}
        onChange={(x) => {
          const valor = x.target.value;
          if (valor === "" || (Number(valor) >= 1 && Number(valor) <= 99)) {
            setEdad(valor);
          }
        }}
        style={inputStyle}
        min="1"
        max="99"
      />
      
      <label>Ingreso al fondo (mensualmente):</label>
      <input 
        type="number" 
        value={ingreso} 
        onChange={(e) => setIngreso(e.target.value)} 
        style={inputStyle} 
      />
      
      <label>Tiempo (años):</label>
      <select 
        value={tiempo} 
        onChange={(e) => setTiempo(e.target.value)} 
        style={inputStyle}
      >
        {[...Array(25)].map((_, i) => (
          <option key={i + 1} value={i + 1}>{i + 1}</option>
        ))}
      </select>
      
      <button onClick={handleSubmit} style={buttonStyle}>
        Crear Cálculo
      </button>
    </div>
  );
}

// ===== COMPONENTE PRINCIPAL =====
export default function Homepage() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // ===== ESTADOS =====
  const [start, setStart] = useState(0);
  const [startSeguros, setStartSeguros] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [animatingSeguros, setAnimatingSeguros] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // ===== EFECTOS =====
  useEffect(() => {
    if (location.state?.scrollTo) {
      const sectionId = location.state.scrollTo;
      const section = document.getElementById(sectionId);
      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  useEffect(() => {
    const checkMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    setIsMobile(checkMobile);
  }, []);

  // ===== VARIABLES COMPUTADAS =====
  const visible = plans.slice(start, start + 4);
  const visibleSeguros = seguros.slice(startSeguros, startSeguros + 3);

  // ===== FUNCIONES DE NAVEGACIÓN =====
  const handlePlanClick = (title) => {
    const routes = {
      "Vivienda": "/CalculadoraVivienda",
      "Evento Especial": "/CalculadoraEventoEspecial",
      "Fondo de salud": "/CalculadoraFondoSalud",
      "Fondo de retiro": "/CalculadoraRetiro",
      "Fondo Educacion": "/CalculadoraEducacion",
      "Fondo de vacaciones": "/CalculadoraConocerMundo",
      "Fondo de año sabatico": "/CalculadoraSabatico",
    };
    if (routes[title]) navigate(routes[title]);
  };

  const handleSeguroClick = (title) => {
    const routes = {
      "Seguro de Auto": "/SeguroDeAuto",
      "Seguro de Vida": "/SeguroDeVida",
      "Seguro de Hogar": "/SeguroDelHogar",
      "Seguro Médico": "/SeguroDeGastosMedicosMayores",
      "Seguro de viajes": "/SeguroDeViajes",
    };
    if (routes[title]) navigate(routes[title]);
  };

  // ===== FUNCIONES DE CARRUSEL =====
  const next = () => {
    if (start + 4 < plans.length) {
      setAnimating(true);
      setTimeout(() => {
        setStart(start + 1);
        setAnimating(false);
      }, 300);
    }
  };

  const prev = () => {
    if (start > 0) {
      setAnimating(true);
      setTimeout(() => {
        setStart(start - 1);
        setAnimating(false);
      }, 300);
    }
  };

  const nextSeguros = () => {
    if (startSeguros + 3 < seguros.length) {
      setAnimatingSeguros(true);
      setTimeout(() => {
        setStartSeguros(startSeguros + 1);
        setAnimatingSeguros(false);
      }, 300);
    }
  };

  const prevSeguros = () => {
    if (startSeguros > 0) {
      setAnimatingSeguros(true);
      setTimeout(() => {
        setStartSeguros(startSeguros - 1);
        setAnimatingSeguros(false);
      }, 300);
    }
  };

  // ===== RENDERIZADO =====
  return (
    <div style={{ fontFamily: 'sans-serif' }}>
      {/* HEADER */}
      <header style={{
        backgroundColor: '#0c1f4d',
        color: 'white',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: isMobile ? '10px 5%' : '10px 5%',
        gap: isMobile ? '8px' : '0'
      }}>
        {/* LOGO */}
        <div style={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start', alignItems: 'center' }}>
          <img src={logoRD} alt="Logoasesor" style={{ height: isMobile ? '45px' : '90px' }} />
        </div>

        {/* NAVEGACIÓN */}
        <nav style={{
          display: 'flex',
          flexDirection: isMobile ? 'row' : 'row',
          flexWrap: isMobile ? 'wrap' : 'nowrap',
          justifyContent: isMobile ? 'center' : 'flex-start',
          gap: isMobile ? '8px' : '1.5rem',
          alignItems: 'center',
          fontSize: isMobile ? '0.85rem' : '1rem'
        }}>
          <span onClick={() => navigate("/pantallaCIT")} style={navLinkStyle}>Asesoría</span>
          <span onClick={() => document.getElementById("planes")?.scrollIntoView({ behavior: "smooth" })} style={navLinkStyle}>Planes de ahorro</span>
          <span onClick={() => document.getElementById("simulador")?.scrollIntoView({ behavior: "smooth" })} style={navLinkStyle}>Simulador</span>
          <span onClick={() => document.getElementById("seguros")?.scrollIntoView({ behavior: "smooth" })} style={navLinkStyle}>Seguros</span>
          <span onClick={() => navigate("/contacto")} style={navLinkStyle}>Contacto</span>
          <span onClick={() => navigate("/blog")} style={navLinkStyle}>Blog</span>
        </nav>

        {/* INFORMACIÓN DE CONTACTO */}
        <div style={{
          fontSize: isMobile ? '0.85rem' : '0.9rem',
          marginTop: isMobile ? '8px' : '0',
          textAlign: isMobile ? 'center' : 'right',
        }}>
          <div style={{ display: 'block' }}>📞 +52 (653)-103-8410</div>
          <div style={{ display: 'block' }}>✉️ ricardodiaztuasesorfinanciero@gmail.com</div>
        </div>
      </header>

      {/* HERO SECTION */}
      <section style={{
        position: 'relative',
        height: '400px',
        backgroundImage: `url('https://www.segurosyfinanzashoy.com/wp-content/uploads/2023/12/sector-financiero-qu-1536x1023.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
      }}>
        <div style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(180deg, rgba(12,31,77,0.85) 30%, rgba(12,31,77,0.6) 70%, rgba(12,31,77,0.9) 100%)',
          zIndex: 1,
          borderRadius: '0 0 00px 0px'
        }} />

        <div style={{
          position: 'relative',
          zIndex: 2,
          textAlign: 'center',
          maxWidth: '700px',
          padding: '0 20px',
        }}>
          <h1 style={{ 
            fontSize: isMobile ? '2rem' : '3rem', 
            marginBottom: isMobile ? '0.2rem' : '0.3rem', 
            fontWeight: isMobile ? '150' : '700', 
            textShadow: '2px 2px 8px rgba(0,0,0,0.7)' 
          }}>
            Tu futuro financiero comienza hoy
          </h1>
          <p style={{ 
            fontSize: isMobile ? '1.1rem' : '1.2rem', 
            marginBottom: '2rem', 
            fontWeight: isMobile ? '150' : '500', 
            textShadow: '1px 1px 6px rgba(0,0,0,0.6)' 
          }}>
            Planifica, ahorra y protege lo que más importa con asesoría experta.
          </p>
          <div style={{ display: 'flex', gap: '25px', justifyContent: 'center' }}>
            <button
              onClick={() => navigate("/PantallaCIT")}
              style={{
                backgroundColor: '#ffd700',
                color: '#0c1f4d',
                padding: '14px 40px',
                borderRadius: '30px',
                border: 'none',
                fontWeight: '600',
                fontSize: '1.1rem',
                cursor: 'pointer',
                boxShadow: '0 5px 15px rgba(255, 215, 0, 0.6)',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#e6c200'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = '#ffd700'}
            >
              Asesoría
            </button>

            <button
              onClick={() => document.getElementById("simulador")?.scrollIntoView({ behavior: "smooth" })}
              style={{
                backgroundColor: 'transparent',
                color: 'white',
                padding: '14px 40px',
                borderRadius: '30px',
                border: '2px solid white',
                fontWeight: '600',
                fontSize: '1.1rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = 'white';
                e.currentTarget.style.color = '#0c1f4d';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = 'white';
              }}
            >
              Simulador
            </button>
          </div>
        </div>
      </section>

      {/* SECCIÓN PLANES DE AHORRO */}
      <section id="planes" style={{
        padding: isMobile ? '40px 10px' : '60px 20px',
        background: 'linear-gradient(180deg, #f9f9f9, #ffffff)',
        textAlign: 'center',
      }}>
        <h2 style={{
          fontSize: isMobile ? '1.6rem' : '2rem',
          marginBottom: isMobile ? '25px' : '40px',
          fontWeight: '600',
          color: '#0c1f4d',
          letterSpacing: '0.5px'
        }}>
          Planes de ahorro
        </h2>

        <p style={{
          maxWidth: '600px',
          margin: '0 auto ' + (isMobile ? '20px' : '30px'),
          fontSize: isMobile ? '1rem' : '1.1rem',
          color: '#0c1f4d'
        }}>
          ¿Sabías que el 70% de las personas que planifican su ahorro con asesoría profesional logran sus metas financieras en menos tiempo?
          <span
            onClick={() => navigate("/pantallaCIT")}
            style={{
              color: '#0c1f4d',
              cursor: 'pointer',
              textDecoration: 'underline',
              marginLeft: '5px'
            }}
            title="Agenda tu cita ahora"
          >
            ¡Agenda tu cita hoy y empieza a planear tu futuro!
          </span>
        </p>

        {isMobile && (
          <p style={{
            fontSize: "1.1rem",
            color: "#666",
            marginTop: "12%",
            marginBottom: "1%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
          }}>
            <span role="img" aria-label="mano">👉</span> Desliza para ver más
          </p>
        )}

        <div style={{
          display: "flex",
          justifyContent: isMobile ? "flex-start" : "center",
          alignItems: "center",
          gap: isMobile ? "15px" : "30px",
          flexWrap: isMobile ? "nowrap" : "wrap",
          overflowX: isMobile ? "scroll" : "visible",
          paddingBottom: isMobile ? "10px" : "0",
          scrollBehavior: "smooth",
          scrollSnapType: isMobile ? "x mandatory" : "none",
          WebkitOverflowScrolling: "touch",
        }}>
          {/* Botón Anterior (solo PC) */}
          {!isMobile && (
            <button
              onClick={prev}
              style={{
                fontSize: "2.2rem",
                background: "none",
                border: "none",
                color: "#0c1f4d",
                cursor: "pointer",
                transition: "color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#1a3b8b")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#0c1f4d")}
            >
              «
            </button>
          )}

          {/* Tarjetas de Planes */}
          {(isMobile ? plans : visible).map((plan, index) => (
            <div
              key={index}
              onClick={() => handlePlanClick(plan.title)}
              style={{
                flex: isMobile ? "0 0 90%" : "0 0 auto",
                maxWidth: isMobile ? "90%" : "260px",
                backgroundColor: "white",
                borderRadius: "20px",
                boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                padding: "20px 15px",
                textAlign: "center",
                cursor: "pointer",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                scrollSnapAlign: isMobile ? "center" : "none",
              }}
              onMouseEnter={e => {
                if (!isMobile) {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                }
              }}
              onMouseLeave={e => {
                if (!isMobile) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.08)';
                }
              }}
              title={`Ver detalles de ${plan.title}`}
            >
              <img
                src={plan.image}
                alt={plan.title}
                loading="lazy"
                style={{
                  width: "100%",
                  height: isMobile ? "180px" : "150px",
                  objectFit: "cover",
                  borderRadius: "12px",
                  marginBottom: "15px",
                  backgroundColor: "#f5f5f5",
                  transition: "opacity 0.3s ease",
                }}
                onLoad={(e) => {
                  e.target.style.opacity = "1";
                }}
                onError={(e) => {
                  e.target.style.backgroundColor = "#e0e0e0";
                  e.target.style.display = "flex";
                  e.target.style.alignItems = "center";
                  e.target.style.justifyContent = "center";
                  e.target.style.fontSize = "12px";
                  e.target.style.color = "#666";
                  e.target.alt = "Imagen no disponible";
                }}
              />
              <h3 style={{ fontSize: "1.2rem", color: "#0c1f4d", marginBottom: "10px" }}>
                {plan.title}
              </h3>
              <p style={{ fontSize: isMobile ? "1rem" : "0.95rem", color: "#333" }}>
                {plan.description}
              </p>
            </div>
          ))}

          {/* Botón Siguiente (solo PC) */}
          {!isMobile && (
            <button
              onClick={next}
              style={{
                fontSize: "2.2rem",
                background: "none",
                border: "none",
                color: "#0c1f4d",
                cursor: "pointer",
                transition: "color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#1a3b8b")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#0c1f4d")}
            >
              »
            </button>
          )}
        </div>
      </section>

      {/* SECCIÓN SIMULADOR */}
      <section id="simulador">
        <CalculadoraSoloAhorrar />
        <p
          onClick={() => navigate("/pantallaCIT")}
          style={{
            marginTop: '25px',
            color: '#0c1f4d',
            textAlign: 'center',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: '1.2rem',
            fontWeight: '600'
          }}
          title="Haz tu cita con nosotros"
        >
          ¿Quieres un plan personalizado? Agenda tu cita ahora mismo!
        </p>
      </section>

      {/* SECCIÓN SEGUROS */}
      <section id="seguros" style={{
        padding: isMobile ? '40px 10px' : '60px 20px',
        background: 'linear-gradient(180deg, #ffffff, #f9f9f9)',
        textAlign: 'center',
      }}>
        <h2 style={{
          fontSize: isMobile ? '1.6rem' : '2rem',
          marginBottom: isMobile ? '25px' : '40px',
          fontWeight: '600',
          color: '#0c1f4d',
          letterSpacing: '0.5px'
        }}>
          Seguros
        </h2>

        {isMobile && (
          <p style={{
            fontSize: "1.1rem",
            color: "#666",
            marginTop: "12%",
            marginBottom: "-0.9%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
          }}>
            <span role="img" aria-label="mano">👉</span> Desliza para ver más
          </p>
        )}

        <div style={{
          display: "flex",
          justifyContent: isMobile ? "flex-start" : "center",
          alignItems: "center",
          gap: isMobile ? "15px" : "30px",
          flexWrap: isMobile ? "nowrap" : "wrap",
          overflowX: isMobile ? "scroll" : "visible",
          paddingBottom: isMobile ? "10px" : "0",
          scrollBehavior: "smooth",
          scrollSnapType: isMobile ? "x mandatory" : "none",
          WebkitOverflowScrolling: "touch",
          opacity: animatingSeguros ? 0 : 1,
          transition: "opacity 0.3s ease",
        }}>
          {/* Botón Anterior (solo PC) */}
          {!isMobile && (
            <button
              onClick={prevSeguros}
              style={{
                fontSize: '2.2rem',
                background: 'none',
                border: 'none',
                color: '#0c1f4d',
                cursor: 'pointer',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={e => e.currentTarget.style.color = '#1a3b8b'}
              onMouseLeave={e => e.currentTarget.style.color = '#0c1f4d'}
            >
              «
            </button>
          )}

          {/* Tarjetas de Seguros */}
          {(isMobile ? seguros : visibleSeguros).map((seguro, index) => (
            <div
              key={index}
              onClick={() => handleSeguroClick(seguro.title)}
              style={{
                flex: isMobile ? "0 0 90%" : "0 0 auto",
                maxWidth: isMobile ? "90%" : "260px",
                backgroundColor: 'white',
                borderRadius: '20px',
                boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
                padding: '20px 15px',
                textAlign: 'center',
                cursor: 'pointer',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                scrollSnapAlign: isMobile ? "center" : "none",
              }}
              onMouseEnter={e => {
                if (!isMobile) {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                }
              }}
              onMouseLeave={e => {
                if (!isMobile) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.08)';
                }
              }}
              title={`Ver detalles de ${seguro.title}`}
            >
              <img
                src={seguro.image}
                alt={seguro.title}
                loading="lazy"
                style={{
                  width: '100%',
                  height: isMobile ? '180px' : '150px',
                  objectFit: 'cover',
                  borderRadius: '12px',
                  marginBottom: '15px',
                  backgroundColor: '#f5f5f5',
                  transition: 'opacity 0.3s ease',
                }}
                onLoad={(e) => {
                  e.target.style.opacity = '1';
                }}
                onError={(e) => {
                  e.target.style.backgroundColor = '#e0e0e0';
                  e.target.style.display = 'flex';
                  e.target.style.alignItems = 'center';
                  e.target.style.justifyContent = 'center';
                  e.target.style.fontSize = '12px';
                  e.target.style.color = '#666';
                  e.target.alt = 'Imagen no disponible';
                }}
              />
              <h3 style={{ fontSize: '1.2rem', color: '#0c1f4d', marginBottom: '10px' }}>
                {seguro.title}
              </h3>
              <p style={{ fontSize: isMobile ? '1rem' : '0.95rem', color: '#333' }}>
                {seguro.description}
              </p>
            </div>
          ))}

          {/* Botón Siguiente (solo PC) */}
          {!isMobile && (
            <button
              onClick={nextSeguros}
              style={{
                fontSize: '2.2rem',
                background: 'none',
                border: 'none',
                color: '#0c1f4d',
                cursor: 'pointer',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={e => e.currentTarget.style.color = '#1a3b8b'}
              onMouseLeave={e => e.currentTarget.style.color = '#0c1f4d'}
            >
              »
            </button>
          )}
        </div>

        <p
          onClick={() => navigate("/pantallaCIT")}
          style={{
            marginTop: '25px',
            color: '#0c1f4d',
            textAlign: 'center',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: '1.2rem',
            fontWeight: '600'
          }}
        >
          Que tal si hacemos un plan para ti de manera directa, ¡Haz tu cita aquí!
        </p>
      </section>

      {/* FOOTER */}
      <footer style={{
        backgroundColor: '#0c1f4d',
        color: 'white',
        padding: '20px 15px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'left',
        fontSize: '0.85rem',
        lineHeight: '1.4',
        marginTop: '40px'
      }}>
        {/* Información de contacto */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          maxWidth: '400px',
          flex: '1'
        }}>
          <div>📍 Oficina: Cjón. Oaxaca y 26, Plaza Eliza, Local 8, 2do piso.</div>
          <div>📞 <a href="tel:+526531767456" style={{ color: 'white', textDecoration: 'none' }}>+52 (653) 103-8410</a></div>
          <div>✉️ <a href="mailto:correo@gmail.com" style={{ color: 'white', textDecoration: 'none' }}>ricardodiaztuasesorfinanciero@gmail.com</a></div>
          <p style={{ fontSize: '0.75rem', opacity: 0.6, marginTop: '8px' }}>
            © {new Date().getFullYear()} Asesor Financiero
          </p>
        </div>

        {/* Logo */}
        <div style={{
          flex: '1',
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
          <img
            src={logoRD}
            alt="Logo asesor financiero"
            style={{ height: '80px', objectFit: 'contain' }}
          />
        </div>
      </footer>
    </div>
  );
}